import { Box, Stack, Typography, useTheme } from "@mui/material";
import { CircularLoader, RightArrowIcon } from "components";
import type { ReactNode } from "react";

export const ProfileModalOption = ({
  onClick,
  icon,
  label,
  hasRightArrowIcon = true,
  isLoading = false,
  badge,
}: {
  onClick: () => void;
  icon: ReactNode;
  label: string;
  hasRightArrowIcon?: boolean;
  isLoading?: boolean;
  /** Trailing element rendered after the label, e.g. a "New" pill. */
  badge?: ReactNode;
}) => {
  const theme = useTheme();
  return (
    <Stack
      onClick={onClick}
      p="10px 16px"
      direction={"row"}
      gap="10px"
      alignItems={"center"}
      color={theme.palette.lightBg.low}
      sx={{
        cursor: isLoading ? "not-allowed" : "pointer",
        ":hover": {
          bgcolor: theme.palette.neutral["010"],
        },
        transition: "background-color 0.3s",
      }}
    >
      <Box
        display="grid"
        sx={{ placeItems: "center" }}
        width="20px"
        height="20px"
      >
        {isLoading ? (
          <Box
            width="100%"
            height="100%"
            display={"grid"}
            sx={{ placeItems: "center" }}
          >
            <CircularLoader size={16} />
          </Box>
        ) : (
          icon
        )}
      </Box>
      <Typography variant="body-medium" color="inherit">
        {label}
      </Typography>
      {badge && <Box sx={{ ml: "auto", display: "flex" }}>{badge}</Box>}
      {hasRightArrowIcon && (
        <RightArrowIcon color="inherit" sx={{ ml: "auto" }} />
      )}
    </Stack>
  );
};
